/* How-to links: "How to sew in a MagZip" on MagZip zippers, "How to install your ZipperBuddy" on ZipperBuddy.
   Shown in the shop pop-up, on product pages and on the ZipperBuddy page. Added 30 Sep 2026. */
(function () {
  var SEW = { url: '/pages/sew-magzip', text: 'How to sew in a MagZip' };
  var ZB = { url: '/pages/zipperbuddy-install', text: 'How to install your ZipperBuddy' };
  var NOT = /hoodie|jacket|vest|pant|jogger|set\b|shirt|tee|hat|cap|beanie|kids|mug|gift|trainer/i;
  var ONPAGE = /^\/pages\/magzip-zippers/.test(location.pathname);
  function pick(name) {
    name = name || '';
    if (/zipper ?buddy/i.test(name)) return ZB;
    if ((ONPAGE || /magzip|magnetic zipper|top stop|slider|pre-cut|round #|square #|sample pack|water resistant/i.test(name)) && !NOT.test(name) && !/pulls?\b/i.test(name)) return SEW;
    return null;
  }
  function link(g, cls) {
    var a = document.createElement('a');
    a.className = 'ag-howto ' + cls;
    a.href = g.url;
    a.innerHTML = g.text + ' <span aria-hidden="true">→</span>';
    return a;
  }
  var css = document.createElement('style');
  css.textContent = '.ag-howto{display:inline-flex;align-items:center;gap:.4rem;margin:.9rem 0 0;font:700 1rem/1.3 var(--sc-font-display,inherit);color:var(--blue,#2d5fa8);text-decoration:underline;text-underline-offset:3px}.ag-howto:hover{color:var(--black,#211e16)}.ag-howto--zbp{margin:1.2rem auto 0;display:flex;justify-content:center}';
  document.head.appendChild(css);

  /* Shop pop-up */
  function syncPopup() {
    var n = document.getElementById('ppName'), buy = document.getElementById('ppAdd');
    if (!n || !buy) return;
    var row = buy.closest('.buy') || buy.parentElement;
    var have = document.querySelector('#pp .ag-howto');
    var g = pick(n.textContent);
    if (have && (!g || have.getAttribute('href') !== g.url)) { have.remove(); have = null; }
    if (g && !have) row.insertAdjacentElement('afterend', link(g, 'ag-howto--pp'));
  }
  var pn = document.getElementById('ppName');
  if (pn) {
    syncPopup();
    new MutationObserver(syncPopup).observe(pn, { childList: true, characterData: true, subtree: true });
  }

  /* Product page */
  var add = document.getElementById('pdAdd'), h1 = document.querySelector('.pd-info h1');
  var pg = h1 && pick(h1.textContent);
  if (add && pg && !document.querySelector('.ag-howto--pd')) {
    var anchor = document.getElementById('pdAdded') || add.closest('.pd-row') || add;
    anchor.insertAdjacentElement('afterend', link(pg, 'ag-howto--pd'));
  }

  /* ZipperBuddy page: under the how-it-works video */
  if (/^\/pages\/zipperbuddy\/?$/.test(location.pathname)) {
    var vid = document.querySelector('#zb-lp .steps .video');
    if (vid && !document.querySelector('.ag-howto--zbp')) vid.insertAdjacentElement('afterend', link(ZB, 'ag-howto--zbp'));
  }
})();
